module.exports = __webpack_public_path__ + "img/zizhi20.38aa6fc1.png";